"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFormText = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcFormLayout_1 = require("./AcFormLayout");
var clsx_1 = __importDefault(require("clsx"));
var AcFormText = function (props) {
    var fieldName = props.fieldName, value = props.value, _a = props.placeholder, placeholder = _a === void 0 ? '選択してください' : _a, onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus, size = props.size, inputRef = props.inputRef, className = props.className, disabled = props.disabled, readOnly = props.readOnly, plaintext = props.plaintext, required = props.required, clearable = props.clearable;
    var onFormControlChange = function (e) {
        if (onChange) {
            onChange(fieldName, e.target.value);
        }
    };
    var onFormControlBlur = function (e) {
        if (onBlur) {
            onBlur(fieldName, e.target.value);
        }
    };
    var onFormControlFocus = function (e) {
        if (onFocus) {
            onFocus(fieldName, e.target.value);
        }
    };
    // Offset Padding for Append Icon
    var offsetPaddingRight = function () {
        var paddingRight = 12; // default
        if (required)
            paddingRight += 34;
        if (clearable)
            paddingRight += 28;
        return paddingRight;
    };
    return (react_1.default.createElement(AcFormLayout_1.AcFormLayout, __assign({}, props, { type: "text", formControl: react_1.default.createElement(react_bootstrap_1.Form.Control, { size: size, ref: inputRef, className: clsx_1.default(className), onChange: onFormControlChange, onBlur: onFormControlBlur, disabled: disabled, onFocus: onFormControlFocus, placeholder: placeholder, plaintext: plaintext, readOnly: readOnly, value: (value !== null && value !== void 0 ? value : ''), style: {
                paddingRight: offsetPaddingRight(),
            } }) })));
};
exports.AcFormText = AcFormText;
exports.AcFormText.displayName = 'AcFormText';
//# sourceMappingURL=AcFormText.js.map